import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import authService from '../../utils/authService';

const ProtectedRoute = ({ children, allowedRoles = [], redirectTo = '/login' }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const location = useLocation();

  useEffect(() => {
    checkAuthorization();
  }, [location?.pathname]);

  const checkAuthorization = async () => {
    try {
      // Check if user is authenticated
      if (!authService?.isAuthenticated()) {
        setIsAuthorized(false);
        setIsLoading(false);
        return;
      }

      // ✅ ROUTE GUARD - Check for mandatory password change
      const currentUser = authService?.getCurrentUser();
      const mustChangePassword = currentUser?.must_change_password === true;
      const isPasswordChangeRoute = location?.pathname === '/mandatory-password-change';
      const isLogoutRoute = location?.pathname === '/logout';
      
      if (mustChangePassword && !isPasswordChangeRoute && !isLogoutRoute) {
        console.log('🔒 User must change password, forcing redirect to password change screen');
        setIsAuthorized(false);
        setIsLoading(false);
        return;
      }

      // Check role-based authorization
      if (allowedRoles?.length > 0) {
        const hasRequiredRole = authService?.hasAnyRole(allowedRoles);
        setIsAuthorized(hasRequiredRole);
      } else {
        // If no specific roles required, just check authentication
        setIsAuthorized(true);
      }
    } catch (error) {
      console.error('Authorization check failed:', error);
      setIsAuthorized(false);
    } finally {
      setIsLoading(false);
    }
  };

  // Show loading state while checking authorization
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Verificando acceso...</p>
        </div>
      </div>
    );
  }

  // ✅ ROUTE GUARD - Handle mandatory password change redirect
  const currentUser = authService?.getCurrentUser();
  const mustChangePassword = currentUser?.must_change_password === true;
  const isPasswordChangeRoute = location?.pathname === '/mandatory-password-change';
  const isLogoutRoute = location?.pathname === '/logout';
  
  if (authService?.isAuthenticated() && mustChangePassword && !isPasswordChangeRoute && !isLogoutRoute) {
    return (
      <Navigate 
        to="/mandatory-password-change" 
        replace 
      />
    );
  }

  // Redirect to login if not authorized
  if (!isAuthorized) {
    return (
      <Navigate 
        to={redirectTo} 
        state={{ from: location?.pathname }} 
        replace 
      />
    );
  }

  // Render protected content
  return children;
};

export default ProtectedRoute;